import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const gbp = (n, digits = 0) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: digits, minimumFractionDigits: digits }).format(n || 0);

export async function startCheckout(lookup_key, extra = {}) {
  const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin, ...extra });
  window.location.href = data.checkout_url;
}

export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");

export const TYPE_LABEL = { brief: "Daily Brief", analysis: "Analysis", research: "Research Paper", newsletter: "Tuesday Roast", report: "Sector Report" };
export const ACCESS_LABEL = { free: "Free", pro: "Pro", institutional: "Institutional" };
export const CATEGORIES = ["Commodities", "Specialty Coffee", "UK-Africa Corridor", "AfCFTA & Trade Policy", "EUDR & Traceability", "CPG & Food Sovereignty", "Agritech", "Investment", "Hospitality & Food Culture"];

export const EDITOR_LINKEDIN = "https://www.linkedin.com/in/wilbert-chaniwa-533092356";
